/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {GestioneVisoriWidget} from '../../../_metronic/partials/widgets/customs/GestioneVisoriWidget'

export function GestioneVisori() {
  return (
    <>	
      <div className='col-xl-12'>
        <GestioneVisoriWidget className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </>
  )
}
